<div class="health-dashboard">
  <div class="dashboard-header mb-25">
    <div
      fxLayout="row"
      fxLayoutAlign="space-between center"
      fxLayoutGap="14px"
      fxLayout.xs="column"
      fxLayoutAlign.xs="start stretch"
    >
      <div class="title">
        <h4 class="mb-0">Painel de Plantões</h4>
        <div class="subtitle">
          <span class="subtitle-text"
            >Visão rápida para gestores de hospital/clínica.</span
          >
          <mat-chip class="today-chip" disableRipple>
            <i class="ri-calendar-2-line"></i>
            {{ today | date: "fullDate" : undefined : "pt-BR" }}
          </mat-chip>
        </div>
      </div>

      <div
        fxLayout="row"
        fxLayoutAlign="end center"
        fxLayoutGap="10px"
        class="header-actions"
      >
        <span class="updated-at" *ngIf="lastUpdatedAt"
          >Atualizado às {{ lastUpdatedAt | date: "HH:mm" }}</span
        >
        <button
          type="button"
          mat-raised-button
          class="tagus"
          (click)="refresh()"
          [disabled]="loading"
        >
          <i class="ri-refresh-line"></i>
          Atualizar
        </button>
      </div>
    </div>
    <mat-progress-bar
      *ngIf="loading"
      mode="indeterminate"
      class="header-loader"
    ></mat-progress-bar>
  </div>

  <div class="stats-grid mb-25">
    <mat-card class="tagus-card stat-card">
      <mat-card-content>
        <div class="stat">
          <div class="icon bg-emerald">
            <i class="ri-calendar-schedule-line"></i>
          </div>
          <div class="meta">
            <span class="label">Plantões hoje</span>
            <h3 class="value mb-0">{{ stats.todayTotal }}</h3>
          </div>
        </div>
        <div class="hint">
          Abertos: <strong>{{ stats.todayOpen }}</strong> • Em andamento:
          <strong>{{ stats.inProgress }}</strong>
        </div>
      </mat-card-content>
    </mat-card>

    <mat-card class="tagus-card stat-card">
      <mat-card-content>
        <div class="stat">
          <div class="icon bg-sky">
            <i class="ri-shield-cross-line"></i>
          </div>
          <div class="meta">
            <span class="label">Cobertura hoje</span>
            <h3 class="value mb-0">{{ stats.coveragePct }}%</h3>
          </div>
        </div>
        <mat-progress-bar
          class="coverage-bar"
          mode="determinate"
          [value]="stats.coveragePct"
        ></mat-progress-bar>
        <div class="hint" *ngIf="stats.todayTotal === 0">
          Sem plantões para hoje.
        </div>
        <div class="hint" *ngIf="stats.todayTotal > 0">
          Cancelados: <strong>{{ stats.cancelled }}</strong> • Faltas:
          <strong>{{ stats.noShow }}</strong>
        </div>
      </mat-card-content>
    </mat-card>

    <mat-card class="tagus-card stat-card">
      <mat-card-content>
        <div class="stat">
          <div class="icon bg-amber">
            <i class="ri-alarm-warning-line"></i>
          </div>
          <div class="meta">
            <span class="label">Plantões abertos</span>
            <h3 class="value mb-0">{{ stats.todayOpen }}</h3>
          </div>
        </div>
        <div class="hint">Priorize cobertura nas próximas horas.</div>
      </mat-card-content>
    </mat-card>

    <mat-card class="tagus-card stat-card">
      <mat-card-content>
        <div class="stat">
          <div class="icon bg-indigo">
            <i class="ri-team-line"></i>
          </div>
          <div class="meta">
            <span class="label">Profissionais</span>
            <h3 class="value mb-0">{{ stats.professionals }}</h3>
          </div>
        </div>
        <div class="hint">
          <a routerLink="/professionals" class="link">Gerenciar cadastro</a>
        </div>
      </mat-card-content>
    </mat-card>
  </div>

  <div class="main-grid">
    <div class="main-left">
      <mat-card class="tagus-card main-card">
        <mat-card-header class="border-bottom">
          <h5 class="mb-0">Próximos plantões</h5>
          <a mat-button class="tagus" routerLink="/shifts">
            <i class="ri-calendar-event-line"></i>
            Ver calendário
          </a>
        </mat-card-header>
        <mat-card-content>
          <div class="loading" *ngIf="loading">Carregando dados...</div>

          <ng-container *ngIf="!loading">
            <mat-list
              class="shift-list"
              *ngIf="nextShifts.length; else emptyNextShifts"
            >
              <mat-list-item *ngFor="let s of nextShifts">
                <div
                  class="shift-item"
                  fxLayout="row"
                  fxLayoutAlign="space-between center"
                  fxFlexFill
                >
                  <div class="left">
                    <div class="primary">
                      <span class="date">{{
                        s.start | date: "EEE, dd/MM" : undefined : "pt-BR"
                      }}</span>
                      <span class="time"
                        >{{ s.start | date: "HH:mm" : undefined : "pt-BR" }}–{{
                          s.end | date: "HH:mm" : undefined : "pt-BR"
                        }}</span
                      >
                      <mat-chip class="status-chip" [ngClass]="s.status">{{
                        statusLabel(s.status)
                      }}</mat-chip>
                    </div>
                    <div class="secondary">
                      <span *ngIf="s.hospital">{{ s.hospital }}</span>
                      <span *ngIf="s.department"> • {{ s.department }}</span>
                      <span *ngIf="s.professional">
                        • {{ s.professional }}</span
                      >
                    </div>
                  </div>
                  <a mat-stroked-button class="tagus" routerLink="/shifts"
                    >Ver no calendário</a
                  >
                </div>
              </mat-list-item>
            </mat-list>

            <ng-template #emptyNextShifts>
              <div class="empty-state">
                <div class="empty-icon">
                  <i class="ri-calendar-check-line"></i>
                </div>
                <div class="empty-text">
                  <h6 class="mb-0">Nenhum plantão futuro encontrado</h6>
                  <p class="mb-0">
                    Verifique filtros/contratos ou gere novos plantões.
                  </p>
                </div>
                <div class="empty-actions">
                  <a
                    mat-raised-button
                    class="tagus"
                    routerLink="/shifts/generate"
                    >Gerar plantões</a
                  >
                </div>
              </div>
            </ng-template>
          </ng-container>
        </mat-card-content>
      </mat-card>

      <mat-card class="tagus-card main-card mb-10">
        <mat-card-header class="border-bottom">
          <h5 class="mb-0">Ações rápidas</h5>
        </mat-card-header>
        <mat-card-content>
          <div class="quick-actions">
            <a mat-stroked-button class="tagus" routerLink="/shifts">
              <i class="ri-calendar-event-line"></i>
              Plantões
            </a>
            <a mat-stroked-button class="tagus" routerLink="/scales">
              <i class="ri-file-list-3-line"></i>
              Escalas
            </a>
            <a mat-stroked-button class="tagus" routerLink="/departments">
              <i class="ri-hospital-line"></i>
              Setores
            </a>
            <a mat-stroked-button class="tagus" routerLink="/hospitals">
              <i class="ri-building-2-line"></i>
              Unidades
            </a>
            <a mat-stroked-button class="tagus" routerLink="/professionals">
              <i class="ri-stethoscope-line"></i>
              Profissionais
            </a>
            <a mat-stroked-button class="tagus" routerLink="/time-slots">
              <i class="ri-time-line"></i>
              Horários
            </a>
          </div>
        </mat-card-content>
      </mat-card>
    </div>

    <div class="main-right">
      <mat-card class="tagus-card main-card">
        <mat-card-header class="border-bottom">
          <h5 class="mb-0">Alertas & pendências</h5>
          <i class="ri-heart-pulse-line header-icon"></i>
        </mat-card-header>
        <mat-card-content>
          <div class="alert" *ngFor="let a of alerts" [ngClass]="a.level">
            <div class="alert-icon">
              <i
                [ngClass]="{
                  'ri-information-line': a.level === 'info',
                  'ri-alert-line': a.level === 'warning',
                  'ri-error-warning-line': a.level === 'danger',
                }"
              ></i>
            </div>
            <div class="alert-body">
              <h6 class="mb-0">{{ a.title }}</h6>
              <p class="mb-0">{{ a.description }}</p>
            </div>
          </div>
        </mat-card-content>
      </mat-card>

      <mat-card class="tagus-card main-card">
        <mat-card-header class="border-bottom">
          <h5 class="mb-0">Análises pendentes</h5>
          <i class="ri-file-search-line header-icon"></i>
        </mat-card-header>
        <mat-card-content>
          <div class="review-kpis">
            <a
              class="review-kpi"
              [routerLink]="['/professionals']"
              [queryParams]="{ status: 'PENDING' }"
            >
              <span class="label">Profissionais em análise</span>
              <span class="value">{{ review.professionalsPending }}</span>
            </a>
            <a
              class="review-kpi"
              [routerLink]="['/professionals']"
              [queryParams]="{ status: 'REJECTED' }"
            >
              <span class="label">Profissionais rejeitados</span>
              <span class="value">{{ review.professionalsRejected }}</span>
            </a>
            <a
              class="review-kpi"
              [routerLink]="['/professionals/review-files']"
              [queryParams]="{ status: 'PENDING' }"
            >
              <span class="label">Arquivos para revisar</span>
              <span class="value">{{ review.filesPending }}</span>
            </a>
            <a
              class="review-kpi"
              [routerLink]="['/professionals/review-files']"
              [queryParams]="{ status: 'PENDING_UPLOAD' }"
            >
              <span class="label">Aguardando envio</span>
              <span class="value">{{ review.filesPendingUpload }}</span>
            </a>
          </div>

          <div class="review-hint">
            Profissionais com pendência de documentos:
            <strong>{{ review.professionalsWithPendingFiles }}</strong>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</div>
